module.exports = __webpack_public_path__ + "images/computer-c324b93994207419ce426bd21769b4af.jpg";